import ClockComponent from "slotworks/components/header/clock-component";
import SoundToggleComponent from "slotworks/components/sound/sound-toggle-component";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import { RealityMode } from "slotworks/model/settings/settings-model";
import { Services } from "slotworks/services/services";
import gameiomModel from "gameiom/model/gameiom-model";

export default class HeaderComponent {

    private clock: ClockComponent;
    private soundToggle: SoundToggleComponent;
    private mode: string;
    private infoButton: FlexiButton;

    private enabled: boolean = true;

    constructor() {
        Layers.Header.onSceneEnter.add(this.setup);

        this.setup();
    }

    public setEnabled(enable: boolean) {
        this.enabled = enable;

        if (this.infoButton) {
            this.infoButton.setEnabled(this.enabled);
        }
    }

    public setMode(mode: RealityMode) {
        this.mode = mode;

        this.updateMode();
    }

    private setup = () => {
        if (this.clock) {
            this.clock.destroy();
        }

        this.clock = new ClockComponent(gameiomModel.displayClock);

        this.setupSoundToggle();
        this.updateMode();
    }

    private updateMode() {
        const modeLabel = Layers.Header.getFlexiText("mode");
        if (modeLabel && this.mode) {
            modeLabel.setText(Services.translations.get(this.mode));
        }
    }

    private setupSoundToggle() {
        if (this.soundToggle) {
            this.soundToggle.destroy();
            this.soundToggle = null;
        }

        const soundOnButton = Layers.Header.getFlexiButton("sound_on");
        if (soundOnButton) {
            const soundOffButton = Layers.Header.getFlexiButton("sound_off");

            this.soundToggle = new SoundToggleComponent(soundOnButton, soundOffButton);
        }
    }
}
